// extracted by mini-css-extract-plugin
export default {"sildeImg":"BannerDetailModal_sildeImg__hm9Cc"};